module.exports = __webpack_public_path__ + "img/internship.aaa6e003.png";